const meterTypeLabels = {
  temperature: 'Temperatur',
  humidity: 'Luftfugtighed',
  co2: 'CO₂',
  cold_water: 'Målerstand',
  electricity_power: 'Effekt',
  electricity_energy: 'Målerstand',
  hot_water: 'Målerstand',
  heat_cost: 'Målerstand',
  heat_energy: 'Målerstand',
  heat_volume: 'Målerstand',
}

export function getMeterTypeLabel(meterType) {
  return meterTypeLabels[meterType] || meterType
}
